import React from "react";
import { FaFacebookF, FaInstagram, FaTwitter } from "react-icons/fa"; // Ikony mediów społecznościowych
import icon from "../../assets/loboB.png";

const Footer = () => {
  return (
    <footer className="bg-black text-white py-8 border-t border-gray-500">
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-center px-6 gap-4">
        {/* Logo po lewej stronie */}
        <div className="flex items-center">
          <img
            src={icon} // Zmień na ścieżkę do swojego logo
            alt="Logo"
            className="w-24 h-auto"
          />
        </div>

        {/* Odnośniki po prawej stronie */}
        <div className="flex flex-col items-center gap-4">
          <div className="flex space-x-6 mb-4">
            <a href="/oferta" className="hover:text-orange-500">
              Oferta
            </a>
            <a href="/kombinezony" className="hover:text-orange-500">
              Kombinezony
            </a>
            <a href="/pierwsza-wizyta" className="hover:text-orange-500">
              Pierwsza Wizyta
            </a>
            <a href="/kontakt" className="hover:text-orange-500">
              Kontakt
            </a>
          </div>

          {/* Ikony mediów społecznościowych */}
          <div className="flex space-x-4">
            <a
              href="https://www.facebook.com/p/Manufaktura-Formy-Bia%C5%82ystok-61550287396940/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF
                className="text-white hover:text-orange-500"
                size={24}
              />
            </a>
            <a
              href="https://www.instagram.com/manufakturaformy.bialystok/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram
                className="text-white hover:text-orange-500"
                size={24}
              />
            </a>
          </div>
        </div>
      </div>

      {/* Powered by Hyperbay */}
      <div className="text-center mt-6 text-sm text-gray-500 border-t border-gray-500">
        <p>
          Powered by{" "}
          <a
            href="https://hyperbaystudio.com/"
            className="text-orange-500 hover:underline"
          >
            Hyperbay
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
